import Reveal, { Eyebrow } from "@/components/Reveal";
import { ArrowRight } from "lucide-react";

const cases = [
  {
    title: "Título cancelado",
    text: "Você deixou de votar e justificar por eleições seguidas e o título foi cancelado.",
  },
  {
    title: "Nunca se alistou",
    text: "Já mora fora há anos e nunca chegou a tirar o título de eleitor.",
  },
  {
    title: "Cadastro eleitoral fechado",
    text: "Precisa da certidão circunstanciada porque o cadastro do TSE está fechado para o pleito.",
  },
  {
    title: "Passaporte a vencer",
    text: "Tem viagem, entrevista de visto ou renovação de passaporte marcada e não pode esperar.",
  },
];

export default function WhoSection() {
  return (
    <section id="para-quem" className="py-24 md:py-32 border-t border-ink/10" data-testid="who-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal className="flex flex-wrap items-end justify-between gap-6">
          <div>
            <Eyebrow>Para quem é</Eyebrow>
            <h2 className="font-serif font-semibold text-4xl md:text-5xl tracking-tight text-ink mt-4">
              Situações que resolvemos<br className="hidden md:block" /> todos os dias.
            </h2>
          </div>
          <span className="font-mono text-[11px] uppercase tracking-[0.18em] text-ink/55 pb-2">
            Páginas de visto — 04 casos
          </span>
        </Reveal>

        <div className="mt-14 grid sm:grid-cols-2 gap-5">
          {cases.map((c, i) => (
            <Reveal key={c.title} delay={i * 0.08}>
              <div
                className="group relative overflow-hidden bg-white border border-ink/12 p-8 md:p-10 transition-colors duration-500 hover:border-carimbo/40"
                data-testid={`who-card-${i + 1}`}
              >
                <span className="font-mono text-[10px] tracking-[0.2em] text-ink/50 uppercase">
                  Caso {String(i + 1).padStart(2, "0")} / 04
                </span>
                <div className="mt-6 flex items-start gap-4">
                  <ArrowRight className="w-5 h-5 mt-1 text-brass shrink-0 transition-transform duration-500 group-hover:translate-x-1.5" />
                  <div>
                    <h3 className="font-serif font-semibold text-[26px] leading-tight text-ink">{c.title}</h3>
                    <p className="text-ink/60 text-[15px] leading-relaxed mt-3">{c.text}</p>
                  </div>
                </div>
                <div className="pointer-events-none absolute right-6 bottom-6 rounded-md border-2 border-carimbo px-3 py-1 font-mono text-[10px] font-bold uppercase tracking-[0.2em] text-carimbo opacity-0 -rotate-6 scale-150 transition-all duration-500 group-hover:opacity-90 group-hover:scale-100">
                  Analisado
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
